import * as React from 'react';

declare global {
	interface Window {
		adsbygoogle: any;
	}
}

interface IProps {
	dataAdSlot?: string;
}

export const AdsComponent = (props: IProps) => {
	const { dataAdSlot } = props;

	React.useEffect(() => {
		try {
			(window.adsbygoogle = window.adsbygoogle || []).push({});
		} catch (e) {
			console.error(e);
		}
	}, []);

	return (
		<ins
			className="adsbygoogle"
			style={{ display: 'block' }}
			data-ad-client="ca-pub-4439767289267779"
			data-ad-slot={dataAdSlot || '4680526168'}
			data-ad-format="auto"
			data-full-width-responsive="true"
		/>
	);
};
